export default function Hero() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex items-center pt-[72px] pb-16 md:pb-20 overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20atmosphere%20with%20warm%20amber%20and%20deep%20burgundy%20gradient%20curves%2C%20soft%20diffused%20light%20beams%2C%20subtle%20film%20grain%20texture%2C%20modern%20minimalist%20composition%2C%20dark%20theater%20ambience%20with%20warm%20highlights%2C%20elegant%20flowing%20lines%20suggesting%20motion%20and%20entertainment%2C%20no%20text%2C%20abstract%20yet%20sophisticated&width=1800&height=1200&seq=hero-bg-movie-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/25 mb-6">
              <i className="ri-fire-line text-primary-500 text-sm w-4 h-4 flex items-center justify-center"></i>
              <span className="text-xs md:text-sm font-medium text-primary-600 whitespace-nowrap">全网热播 · 每日更新</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold font-heading text-white leading-tight">
              大师兄影视
              <br />
              <span className="text-primary-400">免费高清在线观影平台</span>
            </h1>

            <p className="text-base md:text-lg text-white/70 font-medium mt-6 leading-relaxed max-w-xl">
              大师兄影视汇聚海量正版影视资源，涵盖电影、电视剧、综艺、动漫等全类型内容。每日实时更新最新热播剧集与院线大片，支持高清画质秒开播放，极速加载不卡顿，为您带来流畅无广告的沉浸式观影体验。无论您偏爱悬疑烧脑、温情治愈还是热血动作，这里都有属于您的专属片单。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mt-8">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-white/10 flex items-center justify-center">
                  <i className="ri-movie-line text-base md:text-lg text-primary-400"></i>
                </div>
                <div>
                  <div className="text-lg md:text-xl font-bold text-white">10万+</div>
                  <div className="text-xs text-white/50">影视资源</div>
                </div>
              </div>
              <div className="w-px h-8 bg-white/15 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-white/10 flex items-center justify-center">
                  <i className="ri-user-smile-line text-base md:text-lg text-primary-400"></i>
                </div>
                <div>
                  <div className="text-lg md:text-xl font-bold text-white">500万+</div>
                  <div className="text-xs text-white/50">活跃观众</div>
                </div>
              </div>
              <div className="w-px h-8 bg-white/15 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-white/10 flex items-center justify-center">
                  <i className="ri-speed-up-line text-base md:text-lg text-primary-400"></i>
                </div>
                <div>
                  <div className="text-lg md:text-xl font-bold text-white">秒开播放</div>
                  <div className="text-xs text-white/50">极速加载</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <button
                onClick={() => handleNavClick('#media')}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full transition-all duration-200 text-sm md:text-base whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line mr-2"></i>
                立即观影
              </button>
              <button
                onClick={() => handleNavClick('#features')}
                className="w-full sm:w-auto px-8 py-3.5 bg-white/10 hover:bg-white/20 text-white font-semibold rounded-full border border-white/20 backdrop-blur-sm transition-all duration-200 text-sm md:text-base whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line mr-2"></i>
                了解更多
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-primary-500/20 to-accent-500/20 rounded-3xl blur-3xl"></div>
              <div className="relative rounded-2xl overflow-hidden border border-white/10 shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20with%20warm%20golden%20and%20amber%20lighting%2C%20film%20reels%20dramatic%20scene%20silhouettes%2C%20modern%20streaming%20interface%20mockup%20on%20dark%20background%2C%20elegant%20entertainment%20aesthetic%2C%20professional%20cinematography%20vibe%2C%20no%20text%20or%20logos%2C%20rich%20contrast%20with%20deep%20shadows%20and%20warm%20highlights&width=1200&height=800&seq=hero-main-2026-v2&orientation=landscape"
                  alt="大师兄影视 - 高清在线观影体验"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-6">
                  <div className="flex items-center gap-2 text-white/80 text-xs">
                    <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></span>
                    <span>正在热播 · 高清画质</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}